import React from 'react';
import NumberPicker from '../shared/NumberPicker';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const WeeklyFrequencyStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <NumberPicker
      value={answer}
      onChange={onAnswer}
      min={1}
      max={7}
      unit="run"
      unitPlural="runs per week"
    />
  );
};

export default WeeklyFrequencyStep;
